/* eslint-disable angular/file-name */
angular.module('zc.zenclerkS')
  .directive('zcsShoppingCartAspOnly', zcsShoppingCartAspOnly);

zcsShoppingCartAspOnly.$inject = ['$stateParams', 'Devise', 'ZcsProject'];
function zcsShoppingCartAspOnly($stateParams, Devise, ZcsProject) {
  return {
    restrict: 'A',
    link(scope, elem, attrs) {
      elem.addClass('hidden-shopping-cart-asp');
      const { apikey } = $stateParams;
      if(!apikey) { return }
      const asps = attrs.zcsShoppingCartAspOnly.split(',');

      return Devise.getCurrentUser()
        .then(user => ZcsProject.get(user.id, apikey))
        .then(project => {
          if(!asps.includes(project.shopping_cart_asp)) { return }
          elem.removeClass('hidden-shopping-cart-asp');
        });
    }
  };
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/agency-project-only/agency_project_only.directive.js